import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { useTitle } from "react-use";
import "./styles.css";
import { styled } from "@mui/material/styles";

import { getAllHolidayAndAllHolidayPattern } from "../../../../../actions/holiday";

import CalendarAndListHoliday from "../../../shared/calendar/calendarAndListHoliday";
import HolidayPatternList from "../../../shared/calendar/holidayPatternList";

const StyledRoot = styled("div")({
  marginTop: 28,
  marginBottom: "100px",
  "& .MuiTypography-h6": {
    fontSize: "1.5rem",
  },
});

function CalendarSetting(props) {
  const { company } = props;
  useTitle("ปฎิทิน - HR CORE DATA");

  const dispatch = useDispatch();
  dayjs.extend(isSameOrAfter);

  useEffect(() => {
    if (company) {
      dispatch(getAllHolidayAndAllHolidayPattern(dayjs(new Date()).format("YYYY"), company.idCompany));
    }
  }, [company]);

  return (
    <StyledRoot>
      <CalendarAndListHoliday isReadOnly={true} />
      <HolidayPatternList isReadOnly={true} />
    </StyledRoot>
  );
}

export default CalendarSetting;
